import { render, staticRenderFns } from "./ZoneEdit.vue?vue&type=template&id=5cf2c9ae&"
import script from "./ZoneEdit.vue?vue&type=script&lang=ts&"
export * from "./ZoneEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports